import useBreakpoint from 'src/common/hooks/ui/useBreakpoint'
import { thirdwebCommonConnectConfig } from 'src/config/thirdweb'
import { ConnectButtonProps } from 'thirdweb/react'
import ConnectWalletDesktop from './ConnectWallet.desktop'
import ConnectWalletMobile from './ConnectWallet.mobile'
import { signupWithWallet } from 'src/common/api-clients/swarm/passport'
import { useAtomValue, useSetAtom } from 'jotai'
import {
  kycModalAtom,
  verifyModalAtom,
} from 'src/pages/TradePage/stores/trade-store'
import { Wallet } from 'thirdweb/wallets'
import useTier2 from 'src/common/queries/useTier2'

const ConnectWallet: React.FC = () => {
  const isSm = useBreakpoint('xs')
  const kycModal = useAtomValue(kycModalAtom)
  const setVerifyModal = useSetAtom(verifyModalAtom)
  const { refetch } = useTier2()
  const connectWalletProps: ConnectButtonProps = {
    autoConnect: true,
    detailsModal: {
      showTestnetFaucet: false,
      hideReceiveFunds: true,
      hideBuyFunds: true,
    },
    connectModal: {
      title: 'Sign up or Sign in',
      termsOfServiceUrl: 'https://docs.swarm.com/about/terms/tos',
    },
    ...thirdwebCommonConnectConfig,
    onConnect: async (wallet: Wallet) => {
      const { new: isNew } = await signupWithWallet(wallet)
      if (isNew && !kycModal) setVerifyModal(true)
      if (wallet.getAccount()) {
        refetch()
      }
    },
  }

  if (isSm) return <ConnectWalletMobile {...connectWalletProps} />
  return <ConnectWalletDesktop {...connectWalletProps} />
}

export default ConnectWallet
